// 画面の描き直しの間隔を 1/60 秒の倍数へ寄せる (2026-11-04・開発版だけ ?frameSnap=1。配布版は寄せない)。
//   main.ts は requestAnimationFrame の実時間を溜めて 1/60 秒ごとに updateGame を回す (固定の拍・描く時の補間なし)。
//   60Hz の画面でも描き直しの間隔は 15〜18ms で揺れるので、溜めが拍の境目の近くにあると、
//   ある描き直しは 0 回・次は 2 回進む。Mac の Chrome で測ると 600 回の描き直しのうち 0 回が 44・2 回が 41 (約 7% ずつ)。
//   0 回の時は画面全体が止まり、2 回の時は2倍跳ぶ。1/60 秒ずつ撮った動画には出ないので、スローでは滑らかに見える。
//   記録 = docs/research/2026-11-04-hound-walk-judder-60hz.md
import { FIXED_DT } from './balance'

// 120Hz・60Hz・30Hz の画面。1/60 秒の倍数から 2ms 以内なら、その倍数ちょうどとして溜める。
const SNAP_MULS = [0.5, 1, 2] as const
const SNAP_TOL_SEC = 0.002

let snapOn = false

export function setFrameSnap(v: boolean): void { snapOn = v }

export function snapFrameDt(dt: number): number {
  for (const m of SNAP_MULS) if (Math.abs(dt - m * FIXED_DT) < SNAP_TOL_SEC) return m * FIXED_DT
  return dt
}

export function frameSnapDt(dt: number): number { return snapOn ? snapFrameDt(dt) : dt }
